/**
 * Возвращает заголовок квеста текущей недели или последнего квеста.
 *
 * @param {Array<{isCurrentWeek: boolean, title: string}>} quests
 *   Массив объектов квестов:
 *   - `isCurrentWeek` — флаг, что квест за текущую неделю
 *   - `title` — заголовок квеста
 * @returns {string|undefined} Заголовок квеста или undefined, если массив пуст
 */
export function getCurrentWeekTitle(quests) {
  if (!quests?.length) return undefined;

  const reversed = [...quests].reverse();
  return reversed.find((q) => q.isCurrentWeek)?.title ?? reversed[0]?.title;
}
